module.exports = __webpack_public_path__ + "product-compound-capsule-05.jpg?435241c5b7b3ccb3b53c72199eafc08f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-05.jpg
// module id = 102
// module chunks = 0